import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private apiUrl = environment.domain.api + "/appFiscal/usuario";

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      token: token || "",
    });
  }

  login(usuario: string, senha: string): Observable<any> {
    const body = {
      login: usuario,
      senha: senha,
      key_app: "laravel",
    };
    return this.http.post(this.apiUrl, body);
  }

  criarUsuario(
    nome: string,
    login: string,
    senha: string,
    email: string,
    telefone: string,
    cpf_cnpj: string,
    rua: string,
    numero: string,
    bairro: string,
    cidade: string
  ): Observable<any> {
    const body: any = {
      nome,
      login,
      senha,
      email,
      telefone,
      cpf_cnpj,
      rua,
      numero,
      bairro,
      cidade,
    };
    return this.http.post(this.apiUrl + "/criar", body);
  }

  listarUsuario(): Observable<any> {
    return this.http.get(this.apiUrl + "/listar", {
      headers: this.getHeaders(),
    });
  }

  atualizarUsuario(dados: any): Observable<any> {
    return this.http.put(this.apiUrl + "/update", dados, {
      headers: this.getHeaders(),
    });
  }

  salvarImagem(imagemBase64: string, usuarioId: number): Observable<any> {
    const body = {
      file: imagemBase64,
      usuario_id: usuarioId,
    };
    return this.http.post(this.apiUrl + "/salvarImagem", body, {
      headers: this.getHeaders(),
    });
  }
}
